/* eslint-disable */
export default {
  dncAlert: 'この連絡先は通話拒否リストに記載されています。',
} as const;

// @key: @#@"dncAlert"@#@ @source: @#@"This contact is on a Do Not Call list."@#@
